export default "__VITE_ASSET__BZolcsEC__"